import { Phrase } from "./db";

export const defaultPhrases: Phrase[] = [
  { text: "Bird", emoji: "🦜" },
  { text: "Cat", emoji: "🐈" },
  { text: "Moo", emoji: "🐮" },
  { text: "Down", emoji: "⬇" },
  { text: "Happy", emoji: "😊" },
  { text: "No", emoji: "🚫" },
  { text: "Woof", emoji: "🐶" },
  { text: "Up", emoji: "⬆" },
  { text: "Wow", emoji: "😲" },
  { text: "Yes", emoji: "👍" },
];
